export default __webpack_public_path__ + "static/media/inputError.aca9067e.svg";